import { SetStateAction } from "react";
import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import { removeAccents } from "../../../utils/removeAccents";

export const newNotificationsModal = ({
  t,
  user,
  usersListArray,
  windowValues,
  setWindowValues,
  updateWindowValue,
  setModalData,
  packUpdateWindow,
  closeMsg,
}: stdObject) => {
  return {
    title: t("p.newNotification"),
    mainColor: colors.blue,
    blocked: true,
    //inputListStyle: { height: 300 },
    inputs: [
      {
        label: t(`p.title`),
        value: windowValues.text ?? "",
        type: "text",
        style: { width: 300 },
        onChange: (e: { target: { value: SetStateAction<string> } }) =>
          updateWindowValue({
            code: "text",
            value: e.target.value,
            ...packUpdateWindow,
          }),
      },
      {
        label: t(`p.date`),
        value: windowValues.date ?? "",
        type: "datetime-local",
        style: { width: 300 },
        onChange: (e: { target: { value: SetStateAction<string> } }) =>
          updateWindowValue({
            code: "date",
            value: e.target.value,
            ...packUpdateWindow,
          }),
      },
      {
        label: t(`p.user`),
        value: windowValues.search ?? "",
        type: "text",
        style: { width: 300 },
        onChange: (e: { target: { value: SetStateAction<string> } }) =>
          updateWindowValue({
            code: "search",
            value: e.target.value,
            ...packUpdateWindow,
          }),
      },
    ],
    table: usersListArray
      .filter(
        (e: stdObject) =>
          windowValues.search?.trim() === "" ||
          (typeof windowValues.search === "string" &&
            windowValues.search !== "" &&
            removeAccents(e.NOMUSU).includes(
              removeAccents(windowValues.search),
            )) ||
          (windowValues.users ?? []).includes(Number(e.CODUSU)),
      )
      .map((e: stdObject, index: number) => {
        return {
          data: [e.NOMUSU],
          style: {
            textAlign: "center",
            backgroundColor: (windowValues.users ?? []).includes(
              Number(e.CODUSU),
            )
              ? colors.lightGreen
              : index % 2 === 0
                ? colors.lightGrey
                : colors.white,
          },
          onClick: () => {
            let tempUsersList = windowValues;
            if (tempUsersList.users.includes(Number(e.CODUSU))) {
              tempUsersList.users = tempUsersList.users.filter(
                (v: number) => v !== Number(e.CODUSU),
              );
            } else {
              tempUsersList.users.push(Number(e.CODUSU));
            }
            setWindowValues({ ...tempUsersList });
          },
        };
      }),
    buttons: [
      {
        label: windowValues.code > 0 ? t("p.update") : t("p.create"),
        onClick: () => {
          closeMsg();
          setModalData({});
        },
        color: colors.green,
      },
      {
        label: t("p.cancel"),
        onClick: () => {
          closeMsg();
          setModalData({});
        },
        color: colors.darkGrey,
      },
    ],
  };
};
